import { render } from "./OfficeMemoSection.vue?vue&type=template&id=46922b76"
import script from "./OfficeMemoSection.vue?vue&type=script&lang=js"
export * from "./OfficeMemoSection.vue?vue&type=script&lang=js"

import "./OfficeMemoSection.vue?vue&type=style&index=0&id=46922b76&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__